import { Alert, Button, Card, Flex, Typography } from 'antd';
import { IconRefresh } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import type { EventStateImportHistorySectionViewProps } from './EventStateImportHistorySection.types';
import { EvimoTable } from '~/app/components/common/EvimoTable/EvimoTable';

const { Text } = Typography;

export function EventStateImportHistorySectionView({
  columns,
  data,
  error,
  hasInProgress,
  isFetching,
  isLoading,
  onPageChange,
  onRefresh,
  page,
  pageSize,
  total,
}: EventStateImportHistorySectionViewProps) {
  const { t } = useTranslation('componentSchema');

  return (
    <Card>
      <Flex justify="space-between" align="center" style={{ marginBottom: 16 }}>
        <Flex vertical>
          <Text strong>{t('importHistory.title')}</Text>
          <Text type="secondary">{t('importHistory.description')}</Text>
        </Flex>
        <Flex align="center" gap={12}>
          {hasInProgress ? (
            <Text type="secondary">{t('importHistory.pollingActive')}</Text>
          ) : null}
          <Button icon={<IconRefresh size={14} />} onClick={onRefresh}>
            {isFetching
              ? t('importHistory.refreshing')
              : t('importHistory.refresh')}
          </Button>
        </Flex>
      </Flex>

      {error ? (
        <Alert
          type="error"
          showIcon
          style={{ marginBottom: 16 }}
          message={t('importHistory.loadFailed')}
          description={error}
        />
      ) : null}

      <EvimoTable
        rowKey="id"
        columns={columns}
        dataSource={data}
        loading={isLoading}
        pagination={{
          current: page,
          pageSize,
          total,
          showSizeChanger: true,
          onChange: onPageChange,
        }}
      />
    </Card>
  );
}
